import { Link } from 'react-router-dom'
import { Seo } from '../components/portal/Seo'

/**
 * 404 page — explains what happened and offers the next action.
 * Reachable from the catch-all route in App.tsx.
 */
export default function NotFoundPage() {
  const popular = [
    { label: 'I Have TB', path: '/i-have-tb' },
    { label: 'Support a Patient', path: '/support-a-patient' },
    { label: 'About TB', path: '/about-tb' },
    { label: 'Resources', path: '/resources' },
    { label: 'Get Help', path: '/get-help' },
  ]
  return (
    <>
      <Seo title="Page not found" noIndex description="The page you were looking for could not be found." />
      <div className="min-h-[70vh] flex items-center justify-center bg-snow-50 p-6">
        <div className="max-w-xl w-full text-center">
          <p className="text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-[rgb(15_76_129)] to-[rgb(0_180_216)] mb-4">
            404
          </p>
          <h1 className="text-2xl font-bold text-snow-900 mb-3">We couldn’t find that page</h1>
          <p className="text-snow-600 mb-8">
            The link may be broken or the page may have moved. Try one of these popular sections, or
            search from the header.
          </p>
          <div className="flex flex-wrap gap-3 justify-center mb-6">
            {popular.map((p) => (
              <Link key={p.path} to={p.path} className="btn-outline btn-sm">
                {p.label}
              </Link>
            ))}
          </div>
          <Link to="/" className="btn-primary">
            Back to home
          </Link>
        </div>
      </div>
    </>
  )
}